var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fifl-footer"},[_c('span',{staticClass:"fifl-inc"},[_vm._v("© FIFL Inc.")])])
}]

export { render, staticRenderFns }